import {
    initializeTimeSuggestions,
    refreshTimeSuggestions,
    setCalendarComponent,
} from '../actions/publicActions';
import { initializeSearchCriteria } from '../mutators/searchCriteriaDialogMutators';
import { setShouldAdjustStartTimeEndTime } from '../mutators/timeSuggestionsMutators';
import { orchestrator } from 'satcheljs';
import {
    setPreviousDate,
    updateTimeSuggestions,
    setPreviousDurationInMinutes,
    setTimeSuggestionsRequestState,
    setLastFindMeetingTimesRequestId,
    setLastFindMeetingTimesRequestDate,
} from '../actions/internalActions';

orchestrator(initializeTimeSuggestions, actionMessage => {
    updateTimeSuggestions(null);
    setPreviousDate(null);
    setPreviousDurationInMinutes(0);
    setTimeSuggestionsRequestState(null);
    setLastFindMeetingTimesRequestId(null);
    setLastFindMeetingTimesRequestDate(null);
    setShouldAdjustStartTimeEndTime(actionMessage.shouldAdjustStartTimeEndTime);
    setCalendarComponent(actionMessage.calendarComponent);
    initializeSearchCriteria(actionMessage.event);
    refreshTimeSuggestions(actionMessage.event, true /* attendeesChanged */);
});
